<template>
  <v-app-bar app :clipped-left="true" dense>
    <v-btn icon @click.stop="toggleLeftNavDrawer" class="hidden-lg-and-up">
      <v-icon>menu</v-icon>
    </v-btn>
    <v-toolbar-title to="/people" class="mr-2">{{ mainTitle }}</v-toolbar-title>
    <!-- <v-btn
      icon
      to="/people"
    >
      <v-icon>home</v-icon>
    </v-app-> -->
    <v-toolbar-items>
      <v-btn text to="/people">
        <v-icon>people</v-icon>
        People
      </v-btn>
      <v-btn text to="/admin" v-if="currentUserCan('accessAdminScreens')">
        <v-icon>settings</v-icon>
        Admin
      </v-btn>
    </v-toolbar-items>
    <!-- <v-btn text to="/admin">
      <v-icon>settings</v-icon>
      Admin
    </v-btn> -->
    <!-- <v-btn
      flat
      to="/cases"
    >
      <v-icon>assessment</v-icon>
      Compliance
    </v-btn> -->
    <v-spacer></v-spacer>
    <v-text-field
      @keyup.enter="searchSubmit"
      type="search"
      hide-details
      prepend-icon="search"
      single-line
      placeholder="Search by name or reg # ..."
      v-model="searchText"
    />

    <v-btn icon @click="logout">
      <v-icon>lock</v-icon>
    </v-btn>
    <v-btn
      icon
      @click.stop="toggleRightNavDrawer"
      :class="{ 'hidden-lg-and-up': $store.state.ui.openRightNavDrawer }"
    >
      <v-icon>menu</v-icon>
    </v-btn>
  </v-app-bar>
</template>

<script>
import { UI_TOGGLE_LEFT_NAV, UI_TOGGLE_RIGHT_NAV } from "@/store/actions";
import { mapState, mapMutations, mapActions } from "vuex";

export default {
  data() {
    return {
      searchText: "",
      mainTitle: process.env.VUE_APP_TITLE
    };
  },
  computed: {
    ...mapState({ open: "ui.openLeftNavDrawer" })
  },
  methods: {
    ...mapMutations({
      toggleLeftNavDrawer: UI_TOGGLE_LEFT_NAV,
      toggleRightNavDrawer: UI_TOGGLE_RIGHT_NAV
    }),
    ...mapActions({
      logout: "LOGOUT"
    }),
    searchSubmit() {
      if (isNaN(this.searchText)) {
        this.$router.push(`/people?s=${this.searchText}`);
      } else {
        this.$router.push(`/people/${this.searchText}`);
      }
    }
  },
  created() {
    if (this.$route.query.q) {
      this.searchText = this.$route.query.q;
    }
  }
};
</script>
